import { gettext } from '@eventbrite/i18n';

export const MORE_COLLECTIONS_FROM_THIS_ORGANIZER_TITLE = gettext(
    'More collections from this organizer',
);
export const OTHER_EVENTS_YOU_MAY_LIKE_TITLE = gettext(
    'Other events you may like',
);
